import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiResponse } from '@app/shared/models';
import { environment } from '@env/environment';
import { forkJoin, map, Observable, of } from 'rxjs';
import { Exchange, ExchangeDto, ExchangeRates } from '@app/store/models';
import { Facility, Pricing } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getChainPrices(id: string): Observable<Pricing | null> {
        return this.httpClient.get<ApiResponse<Facility>>(`api/chain-store/${id}`).pipe(
            map((response) => {
                if (response.data.pricingConfiguration !== null && response.data.pricingConfiguration !== undefined) {
                    return new Pricing(response.data.pricingConfiguration);
                }
                return null;
            }),
        );
    }

    getStorePrices(id: string): Observable<Pricing | null> {
        return this.httpClient.get<ApiResponse<Facility>>(`api/store/${id}`).pipe(
            map((response) => {
                if (response.data.pricingConfiguration !== null && response.data.pricingConfiguration !== undefined) {
                    return new Pricing(response.data.pricingConfiguration);
                }
                return null;
            }),
        );
    }

    getExchangeRates(): Observable<ExchangeRates> {
        if (environment.exchangeRates.length === 0) {
            return of(new ExchangeRates({}));
        }

        const requests: Record<string, Observable<Exchange>> = Object.fromEntries(
            environment.exchangeRates
                .map((currency) => [
                    [
                        `eur-${currency}`,
                        this.httpClient
                            .get<ApiResponse<ExchangeDto>>(`api/exchange-rate/EUR/${currency.toLocaleUpperCase()}`)
                            .pipe(map((response) => new Exchange(response.data))),
                    ],
                    [
                        `pln-${currency}`,
                        this.httpClient
                            .get<ApiResponse<ExchangeDto>>(`api/exchange-rate/PLN/${currency.toLocaleUpperCase()}`)
                            .pipe(map((response) => new Exchange(response.data))),
                    ],
                ])
                .flat(),
        );

        return forkJoin(requests).pipe(map((data) => new ExchangeRates(data)));
    }
}
